import { Component, Input } from '@angular/core';
import {
  AbstractWorkspaceHostComponent,
  AbstractWorkspaceInputs,
} from '../../shared/abstract-workspace-host.component';
import { ProductionWorkspaceComponent } from './production-workspace.component';

export const productionWorkspaceInputKeys = [
  'projectId',
  'stepId',
  'qaGroupId',
  'templateId',
] as const;

export type ProductionWorkspaceInputs = Pick<
  ProductionWorkspaceComponent,
  (typeof productionWorkspaceInputKeys)[number]
> &
  AbstractWorkspaceInputs;

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- no loading state with on push
@Component({
  selector: 'h3-production-workspace-host',
  templateUrl: '../../shared/abstract-workspace-host.component.html',
  standalone: false,
})
export class ProductionWorkspaceHostComponent
  extends AbstractWorkspaceHostComponent<ProductionWorkspaceComponent>
  implements ProductionWorkspaceInputs
{
  @Input({ required: true, transform: Number }) projectId!: number;
  @Input({ required: true, transform: Number }) stepId!: number;
  // eslint-disable-next-line @angular-eslint/no-input-rename -- legacy input coming from sh3
  @Input({ alias: 'qa_group_id', required: true }) qaGroupId!: string;
  @Input() templateId?: string;

  constructor() {
    super(ProductionWorkspaceComponent, productionWorkspaceInputKeys);
  }

  protected override getProjectId() {
    return this.projectId;
  }
}
